<div class="app-layout">
  @if (isAuthenticated()) {
    <app-sidebar />
  }
  <main class="app-content">
    <div #scrollContainer class="app-content-wrapper">
      @if (isAuthenticated()) {
        <app-topbar [contentScrolled]="isContentScrolled()" />
      }
      <div class="app-content-page">
        <router-outlet />
      </div>
    </div>
  </main>
</div>
<app-toast-layer />
